import { Collection } from "@authory-packages/core";

export const getAllContentCollection = (collections: Collection[]) => collections.find((col) => col.label.toLowerCase() === "all content");
